// External imports
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

// Internal imports
import reportWebVitals from './reportWebVitals';
import navMenuReducer from './features/NavMenu';
import articlesReducer from './features/Articles';
import readerReducer from './features/Reader';
import searchBarReducer from './features/SearchBar'

// Styles
import './index.css';

// Components
import App from './App';

// Pages
import Politics from './pages/Politics';
import Economy from './pages/Economy';
import Internationals from './pages/Internationals';
import Sports from './pages/Sports';
import Technology from './pages/Technology';
import Exchange from './pages/Exchange';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <div>404 not found</div>,
    children: [
      {
        path: 'sections/politics',
        element: <Politics />,
      },
      {
        path: 'sections/economy',
        element: <Economy />,
      },
      {
        path: 'sections/internationals',
        element: <Internationals />,
      },
      {
        path: 'sections/sports',
        element: <Sports />,
      },
      {
        path: 'sections/technology',
        element: <Technology />,
      },
      {
        path: 'sections/exchange',
        element: <Exchange />,
      },
    ],
  },
]);

const store = configureStore({
  reducer: {
    navMenu: navMenuReducer,
    articles: articlesReducer,
    reader: readerReducer,
    searchBar: searchBarReducer
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
